import { Api } from './Api';

const  ENPOINTS = {
    Observation: 'observations',
};

const getAll = signal => {
    return Api.get(ENPOINTS.Observation, signal)
}

const getById = (id, signal) => {
    return Api.get(`${ENPOINTS.Observation}/${id}`, signal);
}

const create = (payload, signal) => {
    return Api.post(`user/${ENPOINTS.Observation}`, payload, signal)
}

const update = (id, payload, signal) => {
    return Api.put(`${ENPOINTS.Observation}/${id}`, payload, signal)
}
const destroy = (id, signal) => {
    return Api.erase(`${ENPOINTS.Observation}/${id}`, signal)
}

export const ObservationService = {
    getAll,
    getById,
    create,
    update,
    destroy
}